/**
 * Otp Type Enumeration
 */
export enum OtpTypeEnum {
  DINERS = "protectedByDiners",
  KUSHKI = "KushkiOTP",
  "3DSECURE" = "3dsecure",
}



// WEBPACK FOOTER //
// ./src/components/WaitingView/OtpTypeEnum.ts